import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@mdi/font/css/materialdesignicons.css'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { setHeadersProvider, setOnUnauthorized } from './services/api'
import { useSessionStore } from './stores/session'
import { useAuthStore } from './stores/auth'
import { logout } from './services/auth'
import './styles/main.scss'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(vuetify)
app.use(router)

const session = useSessionStore()
const auth = useAuthStore()

setHeadersProvider(() => {
  const headers: Record<string, string> = {}
  if (session.accId) {
    headers['x-ax-workspace'] = session.accId
  }
  if (session.supplierHeader) {
    headers['x-ax-supplier'] = session.supplierHeader
  }
  return headers
})

setOnUnauthorized(() => {
  const returnTo = session.clientKey ? `/${session.clientKey}` : '/'
  auth.clear()
  session.clear()
  logout(returnTo)
})

app.mount('#app')
